module.exports = __webpack_public_path__ + "img/footer-img.9c97f6e8.svg";